// extracted by mini-css-extract-plugin
export var breadcrumbs = "SiteLayout-module--breadcrumbs--tmOk2";
export var component = "SiteLayout-module--component--OehC4";
export var content = "SiteLayout-module--content--UEhi3";